var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 196,
    viewBox: "0 0 463 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 36.3374H214.477V195.649H457.435V36.3374Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M462.406 186.711H214.48V195.649H462.406V186.711Z",
    fill: "#18525C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.585 36.3374H212.295V195.649H224.585V36.3374Z",
    fill: "#787878"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M432.627 99.3213H345.357V195.649H432.627V99.3213Z",
    fill: "#B8B8B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M428.732 103.821H349.25V195.649H428.732V103.821Z",
    fill: "#103940"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.25 103.821H428.732V192.095L349.25 112.413V103.821Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3851 0H2.83594V17.3029H14.3851V0Z",
    fill: "#DBDBDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.477 0H202.932V17.3029H214.477V0Z",
    fill: "#DBDBDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.477 11.999H2.83594V195.649H214.477V11.999Z",
    fill: "#EDEDED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.477 54.4487H2.83594V59.9844H214.477V54.4487Z",
    fill: "#38949C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.348 99.3213H10.459V127.931H109.348V99.3213Z",
    fill: "#DBDBDB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.961 102.668H14.8457V124.584H104.961V102.668Z",
    fill: "#3CA2AB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0323 99.3213H33.332V127.931H37.0323V99.3213Z",
    fill: "#DBDBDB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4776 99.3213H82.7773V127.931H86.4776V99.3213Z",
    fill: "#DBDBDB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.477 59.9844H2.83594V64.0237H214.477V59.9844Z",
    fill: "#DBDBDB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M459.227 65.0635H214.477V70.5991H459.227V65.0635Z",
    fill: "#18525C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M459.227 70.5991H214.477V74.6355H459.227V70.5991Z",
    fill: "#B8B8B8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M333.004 99.3213H234.115V127.931H333.004V99.3213Z",
    fill: "#B8B8B8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328.617 102.668H238.502V124.584H328.617V102.668Z",
    fill: "#227482"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M260.692 99.3213H256.988V127.931H260.692V99.3213Z",
    fill: "#B8B8B8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M310.134 99.3213H306.434V127.931H310.134V99.3213Z",
    fill: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.477 36.3359H250.902L410.747 195.648H214.477V36.3359Z",
    fill: "#9C9C9C"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.317 188.894H0V195.649H217.317V188.894Z",
    fill: "#227482"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.582 99.3213H116.312V195.649H203.582V99.3213Z",
    fill: "#DBDBDB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.689 103.821H120.207V195.649H199.689V103.821Z",
    fill: "#227482"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M199.689 132.546H120.207V135.546H199.689V132.546Z",
    fill: "#18525C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M161.451 133.699H158.447V195.649H161.451V133.699Z",
    fill: "#18525C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.442 154.461H154.172V178.111H155.442V154.461Z",
    fill: "#DBDBDB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M165.723 154.461H164.453V178.111H165.723V154.461Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.207 103.821H199.689V192.095L120.207 112.413V103.821Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.daeb27da17e6426bb23fbe76063dd1f9.svg";
export { ForwardRef as ReactComponent };